import { render, staticRenderFns } from "./m-select.vue?vue&type=template&id=23520ead&scoped=true"
import script from "./m-select.vue?vue&type=script&lang=js"
export * from "./m-select.vue?vue&type=script&lang=js"
import style0 from "./m-select.vue?vue&type=style&index=0&id=23520ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23520ead",
  null
  
)

export default component.exports